import vendors from '../../assets/img/Features/15 VENDORS.png';
import operations from '../../assets/img/Features/16 OPERATIONS.png';

export default [
  {
    icon: ["fas", "users"],
    iconText: "VENDORS",
    color: "danger",
    title: "Centralized Vendor Records",
    description:
      "Introducing Vendor Management by CONDOZAK™ - an easy way for Property Managers to keep vendor details, service information, and important records organized in one place. Quickly access the information you need and manage vendor relationships more effectively.",
    image: vendors
  },
  {
    icon: ["fas", "list-check"],
    iconText: "OPERATIONS",
    color: "info",
    title: "Better Service Coordination",
    description:
      "CONDOZAK™ helps Property Managers stay on top of vendor activity by making it easier to coordinate services, track important details, and maintain organized records. With everything available through one platform, managing vendors becomes simpler and more efficient.",
    image: operations,
    inverse: true
  }

];
